import { TagListCollapsibleProperties } from '@/models/common/tag-list-collapsible-properties.model';
import { PopoverPlacement } from '@/models/common/popover-placement.model';
import { TagListItem } from '@/models/common/tag-list-item.model';
import { computed, defineComponent, PropType } from 'vue';
import { DEFAULT_DISPLAY_TAG_LIMIT } from '@/constants/common/default-display-tag-limit.constant';

export default defineComponent({
  name: 'TagListCollapsible',
  props: {
    tagList: {
      type: Array as PropType<TagListCollapsibleProperties['tagList']>,
      required: true,
    },
    displayLimitCount: {
      type: Number as PropType<TagListCollapsibleProperties['displayLimitCount']>,
      default: DEFAULT_DISPLAY_TAG_LIMIT,
    },
    placement: {
      type: String as PropType<TagListCollapsibleProperties['placement']>,
      default: PopoverPlacement.TOP,
    },
    getTagTextColor: {
      type: Function as PropType<(backgroundColor: string) => string>,
      default: undefined,
    },
  },
  setup(props) {
    const popoverTagList = computed<TagListItem[]>(
      () => props.tagList.slice(props.displayLimitCount),
    );

    const hasDisplayPopoverTags = computed<boolean>(() => Boolean(popoverTagList.value.length));

    const getTagStyle = (tagColor: string): Record<string, string> | undefined => {
      return props.getTagTextColor
        ? { color: props.getTagTextColor(tagColor) }
        : undefined;
    };

    return {
      popoverTagList,
      hasDisplayPopoverTags,
      getTagStyle,
    };
  },
});
